<script lang="ts" setup>
import { ref } from 'vue';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import useFlowNavigation from '@Use/useFlowNavigation';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import useWhatsNext from '@Use/useWhatsNext';
import useFlowSteps from '@Use/useFlowSteps';

// Import components
import { GuidedShowcaseLayout, ActionBarLayout } from '@Shared';
import UpcomingStepTile from '@Components/whatsNext/UpcomingStepTile.vue';
import ShowcaseImage from '@Components/shared/ShowcaseImage.vue';

// Setup
const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();

// Flow / navigation
const { advanceFlow, goBackInFlow } = useFlowNavigation();
const { getWhatsNextTasks } = useWhatsNext();
const { getProgressSteps, getCurrentStep } = useFlowSteps();
const upcomingSteps = ref(getWhatsNextTasks());
const steps = getProgressSteps();

// Page state
const isNavigating = ref(false);

// Actions
const continueFlow = () => {
    isNavigating.value = true;
    advanceFlow();
};
</script>

<template>
    <guided-showcase-layout
        title="What happens next"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :steps="steps"
        :current-step="getCurrentStep()">
        <app-form-content-layout>

            <p>Here's what to expect during the next few minutes.</p>

            <app-form-content-layout>

                <div v-for="step in upcomingSteps" :key="step.displayName">
                    <upcoming-step-tile
                        :title="step.displayName"
                        :icon="step.icon"
                        :moreInfo="step.moreInfo"
                    />
                </div>
            </app-form-content-layout>
        </app-form-content-layout>

        <action-bar-layout @back-click="goBackInFlow">
            <app-button
                size="large"
                @onClick="continueFlow"
                :is-loading="isNavigating"
                data-id="request-what-next-continue"
            >
                Continue
            </app-button>
        </action-bar-layout>

        <template #branded>
            <showcase-image />
        </template>
    </guided-showcase-layout>
</template>
